import React, { FC } from 'react';
import Icon from '../icon';
import RoutableSitecoreLink from '../routableSitecoreLink';
import { TCTAWithArrowEditable } from './index.types';
import './styles.scss';

const CTAWithArrow: FC<TCTAWithArrowEditable> = ({ field, target = '' }) => (
  <div className="cta-with-arrow">
    <RoutableSitecoreLink field={field} target={target}>
      {field?.value?.text}
      <span className="cta-with-arrow__text">
        <Icon iconName="arrow-chevron-right" size={24} color="primary" extraClassName="cta-with-arrow__icon" />
      </span>
    </RoutableSitecoreLink>
  </div>
);

export default CTAWithArrow;
